import React from 'react';

const HorizontalBarChart = ({ data, maxValue, height = 40, showPercentage = true }) => {
  // data format: [{ label, value, color }]
  const max = maxValue || Math.max(...data.map(d => d.value));

  return (
    <div className="space-y-4">
      {data.map((item, index) => {
        const percentage = (item.value / max) * 100;
        return (
          <div key={index} className="space-y-1">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">{item.label}</span>
              <span className="text-sm font-bold text-gray-900">
                {showPercentage ? `${item.value}%` : item.value}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full" style={{ height: height }}>
              <div
                className="rounded-full flex items-center justify-end pr-2 transition-all duration-500"
                style={{
                  width: `${percentage}%`,
                  height: height,
                  backgroundColor: item.color || '#1a5d3a'
                }}
              >
                {percentage > 15 && showPercentage && (
                  <span className="text-xs font-semibold text-white">{item.value}%</span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalBarChart;
